import { Component } from 'react';
import TimeLinePiece, { WorkItem } from './timeLinePeice';
import { Fade } from 'react-awesome-reveal';

interface WorkExperienceState {
    experience: WorkItem[];
}

class WorkExperience extends Component<Record<string, never>, WorkExperienceState> {
    state: WorkExperienceState = {
        experience: [
            {
                company: 'Jagex',
                description: `Delivering core P0 business requirements. I have worked across the Core Tech Accounts & Billing teams as well as the Data Engineering team. I've architected and built the martech pipelines that power data flow into our marketing technology systems, engineered integrations for marketing attribution, and ensured our platforms stay compliant with GDPR regulations keeping player data safe while helping the business make smarter, data-driven decisions.`,
                role: 'Senior Full Stack Engineer',
                technologies: 'Terraform,  Github Actions, React.js, Node.js, Java, Golang, AWS, TypeScript, SQL, Python',
            },
            {
                company: 'the LEGO Group',
                description: `Working as part of the Omnichannel Cart services squad at the LEGO Group. Our Squad was responsible for the Cart, Order, Inventory Management and Payment services. Each of which is a standalone service with either event driven or api accessible functions to provide core business logic to the Lego.com website. Our services are hit 10's of millions of times a week and process billions in orders every year.`,
                role: 'Senior Software Engineer',
                technologies: 'Jest, CDK, Dynamodb, Github Actions, React.js, Node.js, AWS, TypeScript',
            },
            {
                company: 'Comparison Tech',
                description: 'Working with the insights team to provide up to date statistics within the market. Capturing and using analytics data within the energy market so create dashboard and statistics to help businesses understand the market and choose the best prices.',
                role: 'Full Stack Engineer',
                technologies: 'Jest, Next.js, React.js, Node.js, Docker, AWS, SQL, TypeScript, CDK, Bitbucket pipelines',
            },
            {
                company: 'Ageas',
                description: 'Creating claims and internal platforms to improve users speed and performance through intuitive and easy to use UI.',
                role: 'Developer',
                technologies: 'React, Node, Typescript, Webpack',
            },
            {
                company: 'Clearvision',
                description: 'Creating the ClearHub contractors platform to allow clients to easily find and recruit contractors as well as assisting on the Clearvision customer facing website.',
                role: 'Developer',
                technologies: 'React, Node, Java, Ruby, PHP, Webpack, AWS',
            },
            {
                company: 'My learning cloud',
                description: 'Working on an e learning platform based in the care industry. Creating interactive learning experiences to help aid in teaching of materials.',
                role: 'Web Developer',
                technologies: 'Angular 2, Pure JS',
            },
            {
                company: 'A Dear Life',
                description: 'Creating unique customer facing websites for clients to ensure the highest possible traffic growth.',
                role: 'Web Developer',
                technologies: 'React, Node, Pure Js, Webpack',
            },
        ],
    };

    renderTimeLineParts() {
        return this.state.experience.map((work, index) => (
            <Fade key={index}>
                <TimeLinePiece work={work} />
            </Fade>
        ));
    }

    render() {
        return (
            <div className='workExperience'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Fade>
                                <h2> Work </h2>
                            </Fade>
                        </div>
                    </div>
                    {this.renderTimeLineParts()}
                </div>
                <svg preserveAspectRatio='none' viewBox='0 0 100 102' height='55' width='50%' xmlns='http://www.w3.org/2000/svg' className='bottomDivider'>
                    <path d='M0 0 L100 100 L100 0 Z' fill='#3c3c3e' stroke='#3c3c3e' />
                </svg>
                <svg preserveAspectRatio='none' viewBox='0 0 100 102' height='55' width='50%' xmlns='http://www.w3.org/2000/svg' className='bottomDivider2'>
                    <path d='M0 0 L100 100 L100 0 Z' fill='#3c3c3e' stroke='#3c3c3e' />
                </svg>
            </div>
        );
    }
}

export default WorkExperience;
